import * as React from "react";
import { createRoot } from "react-dom/client";
// import { BrowserRouter } from "react-router-dom";

import { ThemeProvider } from "@mui/material/styles";

import App from "./App";
import theme from "./theme";

const rootElement = document.getElementById("root");
const root = createRoot(rootElement!);

root.render(
  <ThemeProvider theme={theme}>
    <App />
  </ThemeProvider>
);
